/* eslint-disable no-console */
/* global __resourceQuery */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
;
((query) => __awaiter(this, void 0, void 0, function* () {
    const querystring = yield Promise.resolve().then(() => __importStar(require('querystring')));
    const hmr = yield Promise.resolve().then(() => __importStar(require('./bridge.cjs')));
    const controllers = [];
    const FALLBACK_OPTS = {
        ['bud.overlay']: true,
        ['bud.indicator']: true,
        autoConnect: false,
        timeout: 20 * 1000,
        overlay: false,
        reload: false,
        log: false,
        warn: false,
        name: 'bud',
        overlayWarnings: false,
        path: '/__bud/hmr',
    };
    const options = Object.entries(querystring.parse(query.slice(1))).reduce((a, [k, v]) => {
        if (v === 'true')
            v = true;
        if (v === 'false')
            v = false;
        return Object.assign(Object.assign({}, a), { [k]: v });
    }, FALLBACK_OPTS);
    hmr.setOptionsAndConnect(options);
    console.info(options);
    if (options['bud.indicator']) {
        const controllerModule = yield Promise.resolve().then(() => __importStar(require('../components/indicator/index.cjs')));
        const controller = yield controllerModule.make();
        (controller === null || controller === void 0 ? void 0 : controller.update) && controllers.push(controller);
        console.info(controllers);
    }
    if (options['bud.overlay']) {
        const controllerModule = yield Promise.resolve().then(() => __importStar(require('../components/overlay/index.cjs')));
        const controller = yield controllerModule.make();
        (controller === null || controller === void 0 ? void 0 : controller.update) && controllers.push(controller);
        console.info(controllers);
    }
    hmr.subscribeAll(payload => {
        var _a, _b;
        if (!payload)
            return;
        console.info(payload);
        (_a = payload.warnings) === null || _a === void 0 ? void 0 : _a.map(console.warn);
        (_b = payload.errors) === null || _b === void 0 ? void 0 : _b.map(console.error);
        controllers.map(controller => controller.update(payload));
        if (payload.action === 'reload')
            window.location.reload();
    });
}))(
// @ts-ignore
__resourceQuery);
//# sourceMappingURL=index.cjs.map